import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { FuseConfigService } from "@fuse/services/config.service";
import { HealthEngageCommunicationService } from "../../../health-engage-communication.service";
import { ActivatedRoute } from "@angular/router";

declare global {
    interface Window {
        MobileApi: any;
    }
}

@Component({
    selector: "smart-form-collect-completed",
    templateUrl: "./smart-form-collect-completed.component.html",
})
export class SmartFormCollectCompletedComponent implements OnInit, OnDestroy {
    private _route: ActivatedRoute = inject(ActivatedRoute);

    responseId: string;

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _healthEngageCommunicationService: HealthEngageCommunicationService
    ) {
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
    }

    ngOnInit(): void {
        this._route.queryParams.subscribe(params => {
            const responseId = params['responseId'];
            if (responseId) {
                this.responseId = responseId;
            }
        });

        this._healthEngageCommunicationService.emitChatVisibility(false);
    }

    ngOnDestroy(): void {
        this._healthEngageCommunicationService.emitChatVisibility(true);
    }

    onClose(): void {
        window.parent.postMessage(`[form] completed:${this.responseId}`, "*");
        window.MobileApi?.postMessage(`[form] completed:${this.responseId}`);

    }
}
